import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import { useStyles } from './styles';

export const LoadingOverlay = () => {
  const classes = useStyles();

  return (
    <div className={classes.Overlay}>
      <div className={classes.Loader}>
        <CircularProgress style={{ width: 60, height: 60 }} />
      </div>
    </div>
  );
};
